<template>
  <div>
    <StaticDataTable class="static-table-list">
      <template v-slot:header>
        <tr>
          <th width="35%">Operating Cost</th>
          <th width="30%"><Tooltip label="Thicknesses inclusive of minimum thickness (thickness greater or equal to the minimum)" helpStyle>Minimum Thickness</Tooltip></th>
          <th width="30%"><Tooltip label="Thicknesses exclusive of maximum thickness (thickness less than the maximum)" helpStyle>Maximum Thickness</Tooltip></th>
          <th width="5%" v-if="editing">Action</th>
        </tr>
      </template>
      <template v-slot:body>
        <tr v-for="cost in operatingCostList" :key="cost.id">
          <template v-if="!editing">
            <td class="font-weight-bold">{{cost.operatingCostPerUnit | formatCurrency}} / <span v-html="$options.filters.formatLookupName(uomType, UOMTypeUnitsLookup)" /></td>
            <td>{{cost.minRange}}mm</td>
            <td>{{cost.maxRange}}mm</td>          
          </template>
          <template v-if="editing">
            <td>
              <FormInputCurrency v-model="cost.operatingCostPerUnit" @input="dataUpdated" addon="Cost / Unit" />
            </td>
            <td>
              <FormInputText number="number" v-model="cost.minRange" @input="dataUpdated" addon="mm" />
            </td>
            <td>
              <FormInputText number="number" v-model="cost.maxRange" @input="dataUpdated" addon="mm" />
            </td>
            <td>
              <ActionDropMenu :tableAction="true">
                <DropdownMenuItem @click="deleteCost(cost.id)" icon="fa-trash-alt">Delete Cost</DropdownMenuItem>
              </ActionDropMenu>
            </td>
          </template>
        </tr>
      </template>
      <template v-slot:empty v-if="!editing && operatingCostList.length == 0">
        No station operating costs set
      </template>
    </StaticDataTable>
    <div v-if="editing">
      <FormButton class="btn btn-primary btn-xs" @click="addCost"><i class="far fa-plus"></i> Add Operating Cost</FormButton>
    </div>
  </div>
</template>


<script>
import _ from 'lodash'
import moment from 'moment'
import { v4 as uuidv4 } from 'uuid'

import { UOMTypeUnitsLookup } from '@/store/types'

export default {
  name: 'ProductionOperatingCostList',
  props: {
    editing: Boolean,
    value: Array,
    uomType: String
  },
  watch: {
    value: function() {
      this.operatingCostList = _.cloneDeep(this.$props.value)
    }
  },
  created() {
    this.UOMTypeUnitsLookup = UOMTypeUnitsLookup
  },
  data() {
    return {
      operatingCostList: _.cloneDeep(this.$props.value)
    }
  },
  methods: {
    addCost() {
      this.operatingCostList.push({
        id: `temp-id-` + uuidv4(),
        isNewCost: true,
        operatingCostPerUnit: 0,
        minRange: 0,
        maxRange: 0
      })
      this.dataUpdated()
    },
    deleteCost(id) {
      this.operatingCostList = this.operatingCostList.filter(cost => cost.id != id)
      this.dataUpdated()
    },
    dataUpdated() {
      this.$emit('input', this.operatingCostList)
    }
  }
}
</script>